import {
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';

import { HydratedProposal } from 'entities/Proposal/model/types/ProposalSchema';

import { tableStyles } from '../OrderViewItemSupplierTable.styles';

import type { TFunction } from 'i18next';

type OrderViewItemSupplierTableSkeletonProps = {
    t: TFunction;
    proposals: HydratedProposal[];
};

export const OrderViewItemSupplierTableSkeleton = ({
    t,
    proposals,
}: OrderViewItemSupplierTableSkeletonProps) => {
    return (
        <TableContainer>
            <Table sx={tableStyles}>
                <TableHead>
                    <TableRow>
                        <TableCell
                            className="table-suppliers table-left"
                            colSpan={4}
                        >
                            {t('Suppliers') as string}
                        </TableCell>
                        <TableCell>&nbsp;</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {proposals.map((proposal) => (
                        <TableRow key={proposal.seller.uid}>
                            <TableCell colSpan={4}>
                                <Skeleton
                                    width="300px"
                                    variant="rectangular"
                                    height={26}
                                />
                            </TableCell>
                            <TableCell>&nbsp;</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
